import styled from 'styled-components';
import {HOME_PAGE, JACKPOTS_ITEM, LIVE_STREAMING_ITEM, STATIC_VIDEO_ITEM} from '../../../../themes/css-global-classes';
import {styledByDevice} from '../../../../themes/architecture/styled-by-device';

//.orbit-swiper-wrapper
const DefaultBox = styled.div`
    position: relative;
    width: 100%;
    padding: 0;
    margin: 0 auto;
    overflow: hidden;
`;

//Temporary duplicate style for STATIC_VIDEO_ITEM and LIVE_STREAMING_ITEM
export const PcBox = styled(DefaultBox)`
    .${HOME_PAGE} & {
        width: 90%;
        &.${JACKPOTS_ITEM} {
            width: 100%;
        }
        &.${LIVE_STREAMING_ITEM} {
            width: 104%;
            padding-bottom: 2.5rem;
            padding-top: 1.5rem;
            margin-left: -2%;
            clip-path: polygon(8% 0, 92% 0%, 92% 100%, 8% 100%);
        }
        
        &.${STATIC_VIDEO_ITEM} {
            width: 106%;
            padding-bottom: 1rem;
            margin-left: -3%;
            clip-path: polygon(8% 0, 92% 0%, 92% 100%, 8% 100%);
            overflow: unset;
        }
    }
`;

export const MobileBox = styled(DefaultBox)`
    padding: 0;
`;

export const SwiperWrapperDefaultBox = styledByDevice(PcBox, MobileBox);
